import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function DM_FAQ_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='mt-5'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-5'>What are the typical roles within an Digital Marketing agency?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          This varies depending on the size of your agency and what you tend to specialise in. Below is a list of roles commonly found in a digital marketing agency:
          <br></br><br></br>
          <ul>
            <li>Managing Director/Founder</li>
            <li>Account Manager: as a client you may be assigned an account manager who will touch base with you on your projects and keep you updated.</li>
            <li>Graphic Designer</li>
            <li>UI Designer: This is someone who specialises in user friendly website design.</li>
            <li>Web Developer</li>
          </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>What are keywords?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Keywords are the words and phrases that searchers use– usually on a search engine. These are the words that we use when looking for pages, images, videos, blogs, any kind of information or content on the web really. These keywords need to be strategically inserted into your pages and content.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>How often should I post a blog or post on social media?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Facebook? Aim for once a day and definitely no less than 3 times a week.
          <br></br>Instagram? Once or twice a day.
          <br></br>LinkedIn? At least twice a week and no more than once per day.
          <br></br>Twitter? This one is a bit more varied but generally anywhere from 3-30 tweets per day is good.
          </Typography>
        </AccordionDetails>
      </Accordion>

    </div>
    </div>
  );
}
